import { history } from 'services/history.js'

import css from './sass/itempage.module.scss'
import themeCss from '../components/sass/theme.module.scss'
import { getAuctionStatus } from '../util/dateString'

export default function ItemBrowseSignUp({ auctionDetail }) {  
  if (!auctionDetail) return (<></>)

  const status = getAuctionStatus(auctionDetail.StartTime, auctionDetail.EndTime)
  const signupPath = localStorage.savedAuctionCode ? '/signin' : '/registration'

  const savedItemId = localStorage.getItem('savedItemId')
  const savedFixedItemId = localStorage.getItem('savedFixedItemId')

  let itemTextToDisplay = ""
  if (savedItemId) itemTextToDisplay = "to bid on this item"
  else if (savedFixedItemId) itemTextToDisplay = "to purchase this item"

  let auctionTextToDisplay = ""

  switch (status) {
    case 'before':
      auctionTextToDisplay = `This auction has not started yet. Sign up for the auction ${itemTextToDisplay} when the auction starts.`
      break;
    case 'started':
      auctionTextToDisplay = `This auction is live. Sign up for the auction ${itemTextToDisplay}.`
      break;
    case 'ended':
      auctionTextToDisplay = `This auction has ended.`
      break;
    default:
      auctionTextToDisplay = `You must sign up for the auction to participate.`
  }

  // copied from AuctionFromEmail.js - ignoring if email or public id is used
  // user likely to land here from scanning item URL
  const doSignin = async (e) => {
    e.preventDefault()

    // if (sessionStorage.previewAuctionCode) {
    //   showLoading(true)
    //   const signUpResponse = await registerUserForAuction(auctionDetail.AuctionCode)
    //   showLoading(false)
    //   history.push({pathname: '/auctionhome', search: 'auctionId=' + auctionDetail.AuctionCode})
    // }
    // else {
          history.push({pathname: signupPath})
    // }
  }

  const signupText = 'sign up for the auction'
  const signupTextParts = auctionTextToDisplay.split(new RegExp(`(${signupText})`, 'i'))

  return (
    <div className={css['browse-signup-container']}>
      <p>
        {signupTextParts.map((textPart, index) => (
          textPart.toLowerCase() === signupText ? (
            <a key={`${textPart}-${index}`} className={`${css['browse-signup-link']} ${themeCss['bold-nodecoration']}`}
                href={signupPath} onClick={doSignin}>
              {textPart}
            </a>)
          : (textPart)
        ))}
      </p>
    </div>
  ) 
}
